import styled from "styled-components";

import { NotificationFooterTextContainer } from "shared/components/organisms/AppNotification/components/atoms/NotificationFooterText/styles";

export const CampaignNotificationContainer = styled.div`
  svg * {
    fill: ${({ theme }) => theme.console.pageSubtitleColor};
  }

  ${NotificationFooterTextContainer} {
    margin-top: 0.5rem;
  }
`;
